import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
  TableHeader,
  TableHeaderColumn
} from 'material-ui/Table';

import List from '../../List/List';
import AddButton from './../../AddButton';
import LoadMore from '../../LoadMore';
import { FormattedDate } from 'react-intl';
import ListActionItems from '../../List/ListActionItems';
import LoggedAppBar from '../../LoggedLayout/LoggedAppBar';
import LoadingSpinner from '../../LoadingSpinner';

import IconCheckBox from '../../Icons/IconCheckBox';
import IconCheckBoxChecked from '../../Icons/IconCheckBoxChecked';
import NameFormatter from '../../NameFormatter';

class FanBoxList extends List {
  static contextTypes = {
    muiTheme: React.PropTypes.object
  };

  constructor() {
    super();
    this.confirmRemoveMessage = (
      <FormattedMessage
        id="fanBoxMessage.remove"
        defaultMessage="Are you sure you want to delete message?"
      />
    );
  }

  render() {
    let { add, list, items, hasMore, loading } = this.props;
    let records = list.map(id => items[id]);

    let {
      palette: { labelColor },
      baseTheme: {
        palette: { primary1color }
      }
    } = this.context.muiTheme;

    let tableColumnStyle = {
      color: primary1color,
      boxSizing: 'border-box'
    };

    let tableHeaderStyle = {
      color: labelColor,
      boxSizing: 'border-box'
    };

    let fixedColumnHeaderStyle = Object.assign({}, tableHeaderStyle, {
      width: 140
    });
    let fixedColumnStyle = Object.assign({}, tableColumnStyle, { width: 140 });

    let idColumnStyle = { ...tableColumnStyle, maxWidth: 370 };
    let idHeaderColumnStyle = { ...tableHeaderStyle, maxWidth: 370 };

    let { tableHeaderColumn } = this.context.muiTheme;

    return (
      <div>
        <LoggedAppBar title="Inbox list" isStatic />
        <LoadingSpinner show={loading}>
          <LoadMore active={hasMore} loadMore={() => this.loadMore()}>
            <Table selectable={false}>
              <TableHeader
                adjustForCheckbox={false}
                displaySelectAll={false}
                enableSelectAll={false}
                style={{
                  backgroundColor: tableHeaderColumn.bgColor
                }}
              >
                <TableRow>
                  <TableHeaderColumn style={fixedColumnHeaderStyle}>
                    Published
                  </TableHeaderColumn>
                  <TableHeaderColumn style={idHeaderColumnStyle}>
                    Author
                  </TableHeaderColumn>
                  <TableHeaderColumn style={tableHeaderStyle}>
                    Subject
                  </TableHeaderColumn>
                  <TableHeaderColumn style={fixedColumnHeaderStyle}>
                    Creation date
                  </TableHeaderColumn>
                  <TableHeaderColumn style={fixedColumnHeaderStyle}>
                    Published date
                  </TableHeaderColumn>
                  <TableHeaderColumn style={fixedColumnHeaderStyle}>
                    Options
                  </TableHeaderColumn>
                </TableRow>
              </TableHeader>

              <TableBody displayRowCheckbox={false}>
                {records.length > 0 ? (
                  records.map(
                    ({
                      id,
                      title,
                      published,
                      createDate,
                      publishDate,
                      createdBy
                    }) => (
                      <TableRow key={id}>
                        <TableRowColumn
                          style={Object.assign({}, fixedColumnStyle, {
                            textAlign: 'center'
                          })}
                        >
                          {published ? (
                            <IconCheckBoxChecked />
                          ) : (
                            <IconCheckBox />
                          )}
                        </TableRowColumn>
                        <TableRowColumn style={idColumnStyle}>
                          <NameFormatter user={createdBy}></NameFormatter>
                        </TableRowColumn>
                        <TableRowColumn style={tableColumnStyle}>
                          {title}
                        </TableRowColumn>
                        <TableRowColumn style={fixedColumnStyle}>
                          <FormattedDate value={createDate} />
                        </TableRowColumn>
                        <TableRowColumn style={fixedColumnStyle}>
                          {publishDate ? (
                            <FormattedDate value={publishDate} />
                          ) : (
                            '-'
                          )}
                        </TableRowColumn>
                        <TableRowColumn style={fixedColumnStyle}>
                          <ListActionItems
                            edit={this.props.edit}
                            remove={this.props.delete}
                            published={published}
                            record={items[id]}
                            confirmMessageLabel={this.confirmRemoveMessage}
                          />
                        </TableRowColumn>
                      </TableRow>
                    ),
                  )
                ) : (
                  <TableRow>
                    <TableRowColumn columnNumber={6}>Empty list</TableRowColumn>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </LoadMore>
        </LoadingSpinner>

        <AddButton onClick={add} />
      </div>
    );
  }
}

export default FanBoxList;



// WEBPACK FOOTER //
// ./src/components/FanBox/FanBoxList/FanBoxList.jsx